"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invoiceRouter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("./constants");
const invoice_1 = require("../pages/invoice"); // Tu constante '/app'
exports.invoiceRouter = (0, react_router_dom_1.createBrowserRouter)([
    {
        path: constants_1.ROUTE_INVOICE,
        element: (0, jsx_runtime_1.jsx)(invoice_1.InvoicePage, {}),
    },
], {
    basename: constants_1.ROUTE_BASE,
});
